export const basePrefix = "/travel";

export const durationLimit = 30;

export const DatePatterns = {
	ShortTime: "HH:mm",
	ShortTimePeriod: "h:mm a",
	ShortDateTimeNoYear: "DD/MM HH:mm",
	LongDateTimeNoSeconds: "dd/MM/yyyy HH:mm",

	LongDateTime: "dd/MM/yyyy HH:mm:ss",
	LongDateTimeYearSmall: "dd/MM/yy HH:mm",
	LongDate: "DD/MM/YYYY",
	AltLongDate: "j/n/Y",
	ShortDate: "j/n/Y",
	AltShortDate: "j/n/Y",
	ShortDateNoYear: "j/n",
	AltShortDateNoYear: "j/n",
	LongTime: "G:i:s",
	AltLongDateTime: "j/n/Y H:i:s",
	ShortDateTime: "j/n/Y G:i",
	AltShortDateTime: "j/n/Y H:i",
	LongDateTimeNoYear: "j/n G:i:s",
	ISODateTime: "c",
	NoYearDateTime: "j/n G:i:s",
	LongTimeTwoDigitYear: "j/n/y G:i:s",
	ShortDateTimeTwoDigitYear: "j/n/y G:i",
	ShortDateTwoDigitYear: "j/n/y",
	ChartShortDateTime: "%d/%m/%Y %H:%M:%S"
};

export const onLegalPapersClick = ({ type, lng }) => {
	const link = document.createElement("a");

	if (type === "TermsAndConditions") {
		switch (lng) {
			case "en-GB":
				link.href = `https://www.interamerican.gr/online/wcm/connect/www.interamerican.gr-9114/fecc2394-b33e-4bf7-b9a5-dfcb46a83c4e/oroi-taksidiwtiki-asfalisi-en.pdf?MOD=AJPERES&CVID=nGvWGKe&CVID=nGvWGKe&CVID=nGvWGKe`;
				break;
			case "el-GR":
				link.href = `https://www.interamerican.gr/online/wcm/connect/www.interamerican.gr-9114/8ed7ac1e-21dd-4147-98e7-ed79b7ac8213/oroi-travel+insurance.pdf?MOD=AJPERES&CVID=nWczkq.&CVID=nWczkq`;
				break;
			case "ru-RU":
				link.href = `https://www.interamerican.gr/online/wcm/connect/www.interamerican.gr-9114/3c1f27ee-34be-43b5-83e2-4b1129ba8e56/oroi-taksidiwtiki-asfalisi-rus.pdf?MOD=AJPERES&CVID=nGvWN-x&CVID=nGvWN-x`;
				break;
			default:
				link.href = `https://www.interamerican.gr/online/wcm/connect/www.interamerican.gr-9114/fecc2394-b33e-4bf7-b9a5-dfcb46a83c4e/oroi-taksidiwtiki-asfalisi-en.pdf?MOD=AJPERES&CVID=nGvWGKe&CVID=nGvWGKe&CVID=nGvWGKe`;
				break;
		}
	} else {
		switch (lng) {
			case "en-GB":
				link.href = `https://www.interamerican.gr/online/wcm/connect/www.interamerican.gr-9114/0fc44cab-41eb-4f7a-9d11-8dd70b62241c/ipid-travel-en.pdf?MOD=AJPERES&CVID=nG6x7u5&CVID=nG6x7u5`;
				break;
			case "el-GR":
				link.href = `https://www.interamerican.gr/online/wcm/connect/www.interamerican.gr-9114/8c9c3543-3690-4861-8414-610796535f33/ipid-travel-skier.pdf?MOD=AJPERES&CVID=nWczf..&CVID=nWczf`;
				break;
			case "ru-RU":
				link.href = `https://www.interamerican.gr/online/wcm/connect/www.interamerican.gr-9114/2bd4dbaf-e499-43eb-abfc-118520b04293/ipid-travel-rus.pdf?MOD=AJPERES&CVID=nG6xh20&CVID=nG6xh20`;
				break;
			default:
				link.href = `https://www.interamerican.gr/online/wcm/connect/www.interamerican.gr-9114/0fc44cab-41eb-4f7a-9d11-8dd70b62241c/ipid-travel-en.pdf?MOD=AJPERES&CVID=nG6x7u5&CVID=nG6x7u5`;
				break;
		}
	}
	link.target = "_blank";
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
};
